var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.catalog ? _c('Table', {
    attrs: {
      "class-name": "add-to-catalog-table",
      "value": _vm.selected_items,
      "columns": _vm.columns,
      "rows": _vm.productsWithSelectable,
      "rows-count": _vm.products_count,
      "loading": _vm.products_loading,
      "filters": _vm.products_filters,
      "filters-conf": _vm.filtersConf,
      "placeholder-description": _vm.placeholderDescription,
      "placeholder-title": _vm.placeholderTitle,
      "show-select": true,
      "dense": true,
      "hide-default-footer": _vm.products_count <= _vm.pageSize,
      "autofocus-search": true,
      "selectable-key": "selectable",
      "item-key": "id",
      "item-value": "id"
    },
    on: {
      "input": _vm.updateSelectedItems,
      "on-row-click": _vm.onRowClick,
      "on-filters-change": _vm.onFiltersChange
    },
    scopedSlots: _vm._u([{
      key: "product",
      fn: function fn(props) {
        return [_c('div', {
          staticClass: "product-cell py-2"
        }, [_c('div', {
          staticClass: "text-caption grey--text text--darken-1"
        }, [_vm._v(" " + _vm._s(props.row.upc || "—") + " ")]), _c('ProductName', {
          attrs: {
            "product": props.row
          }
        })], 1)];
      }
    }, {
      key: "catalog",
      fn: function fn(props) {
        return [_c('AddToCatalogCatalogCell', {
          attrs: {
            "catalog-entries": props.row.catalog_entries || [],
            "product-format-name": _vm.productFormatName(props.row)
          }
        })];
      }
    }, {
      key: "format",
      fn: function fn(props) {
        return [_vm.isProductSelected(props.row) ? _c('AddToCatalogCatalogCell', {
          attrs: {
            "product": props.row,
            "show-catalog-entries": false,
            "show-format-picker": true,
            "format-id": _vm.selectedFormat(props.row.id),
            "format-options-list": _vm.formatOptions,
            "formats-loading": _vm.formats_loading,
            "product-format-name": _vm.productFormatName(props.row)
          },
          on: {
            "format-change": function formatChange($event) {
              return _vm.onFormatChange(props.row, $event);
            }
          }
        }) : _vm._e(), !_vm.isProductSelected(props.row) ? _c('span', {
          staticClass: "text-caption grey--text text--darken-1"
        }, [_vm._v(" " + _vm._s(_vm.$translate("selectProductFirst")) + " ")]) : _vm._e()];
      }
    }, {
      key: "unit_amount",
      fn: function fn(props) {
        return [_vm.isProductSelected(props.row) ? _c('v-text-field', {
          staticClass: "unit-amount-input",
          attrs: {
            "value": _vm.selectedUnitAmount(props.row.id),
            "label": _vm.unitAmountLabel,
            "type": "text",
            "inputmode": "decimal",
            "dense": "",
            "outlined": "",
            "hide-details": "",
            "prefix": "€"
          },
          on: {
            "input": function input($event) {
              return _vm.onUnitAmountChange(props.row, $event);
            }
          }
        }) : _c('span', {
          staticClass: "text-caption grey--text text--darken-1"
        }, [_vm._v(" " + _vm._s(_vm.$translate("selectProductFirst")) + " ")])];
      }
    }], null, false, 2475571690)
  }) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }